import cx from 'classnames';
import { WarningFilled as WarningIcon } from 'education-icons';
import { Tooltip } from 'platform-components';
import { POPUP_AXIS, POPUP_DIRECTIONS, GRAVITIES } from 'platform-components/constants';
import { usePopupRefs } from 'platform-components/src/components/popup/usePopupRefs';
import React, { useState, useEffect } from 'react';

import './usage.scss';

interface OwnProps {
    children: React.ReactNode | Array<React.ReactNode>;
    mix?: string;
    popupDirection?: GRAVITIES;
    tooltipMix?: string;
}

interface Props extends OwnProps {}

const Usage = (props: Props) => {
    const { children, mix, popupDirection, tooltipMix } = props;

    const [ref, handlePopupRef, handleTargetRef] = usePopupRefs<HTMLDivElement>();
    const [tooltipShown, setTooltipShown] = useState(false);

    const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setTooltipShown(true);
    };

    const handleMouseLeave = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setTooltipShown(false);
    };

    useEffect(() => {
        if (ref) {
            if (tooltipShown) {
                ref.show();
            } else {
                ref.hide();
            }
        }
    }, [ref, tooltipShown]);

    return (
        <div
            className={cx('usage', mix)}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            ref={handleTargetRef}
        >
            <WarningIcon className="usage__icon" />
            <Tooltip
                mix={tooltipMix}
                // @ts-ignore
                onPopupRef={handlePopupRef}
                popupProps={{
                    direction: popupDirection,
                    axis: POPUP_AXIS.START,
                    offsetLeft: -14,
                    offsetTop: -10,
                    inLayer: true,
                }}
                theme={Tooltip.THEME.WARNING}
            >
                {children}
            </Tooltip>
        </div>
    );
};

Usage.defaultProps = {
    popupDirection: POPUP_DIRECTIONS.BOTTOM,
};

export default Usage;
